import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.less']
})
export class CallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private service:BaseService) {}

  public ngOnInit():void {
      const token = this.route.snapshot.queryParamMap.get('token');
      var apiUrl = this.route.snapshot.queryParamMap.get('apiurl');
      this.service.setToken(token);
      this.service.setApiUrl(apiUrl);
      this.router.navigate(['/']);
  }


}
